import { getReaderModalElements, } from './utils/markup'
import {
  readerModeHandler,
  closeModalClickHandler,
  closeModalKeyHandler,
} from './utils/handlers'

document.addEventListener('DOMContentLoaded', () => {
  const withReaderMode = document.querySelectorAll<HTMLElement>('.uctoday-plugin[data-reader-mode="true"]')

  if (!withReaderMode) {
    return
  }

  withReaderMode.forEach((el) => {
    const requestID = el.dataset.requestId ? el.dataset.requestId : ''
    const links = el.querySelectorAll<HTMLAnchorElement>(`a:not(.post-wrapper a)`)
    const modalElements = getReaderModalElements(requestID)

    if ('message' in modalElements) {
      console.error(modalElements.message)
      return
    }

    const {
      modalPrevious,
      modalNext,
      modalCloseButton,
    } = modalElements

    modalNext.addEventListener('click', async (evt) => readerModeHandler(evt, modalElements))
    modalPrevious.addEventListener('click', async (evt) => readerModeHandler(evt, modalElements))
    modalCloseButton.addEventListener('click', (evt) => closeModalClickHandler(evt, modalElements))

    links.forEach((link) => {
      link.addEventListener('click', async (evt) => readerModeHandler(evt, modalElements))
    })
  })
})

document.addEventListener('keydown', (evt) => {
  const withReaderMode = document.querySelectorAll<HTMLElement>('.uctoday-plugin[data-reader-mode="true"]')

  if (!withReaderMode) {
    return
  }

  withReaderMode.forEach((el) => {
    const requestID = el.dataset.requestId ? el.dataset.requestId : ''
    const modalElements = getReaderModalElements(requestID)
    const isModalOpen = document.querySelector<HTMLElement>('.uctoday-reader-modal:not(.uctoday-reader-modal-closed)')

    if (!isModalOpen) {
      return
    }

    if ('message' in modalElements) {
      console.error(modalElements.message)
      return
    }

    if (evt.key === 'Escape') {
      closeModalKeyHandler()
      return
    }

    readerModeHandler(evt, modalElements)
  })
})